/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MatMultiYearView as ɵa} from './multi-year-view';